The image options for the verification button.
